'use client';

import { useQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

/**
 * 정산정보 등록 여부 — mypage `accountInfo` 의 bank 정보 존재로 판정(무신사·29CM 공용 필드).
 *
 * 설정의 '정산 정보 관리'를 등록(`/create/account`)·변경(`/edit/account`) 라우트로 **직접 분기**하는 데 쓴다.
 * app 레이어가 react-query/query-factory 를 직접 다루지 않도록 feature 훅으로 노출한다. (SID-4631)
 */
export function useSettlementRegistration() {
  const { data, isPending } = useQuery({
    ...curatorQueries.mypage.data(),
  });

  const isRegistered = !!(data?.accountInfo?.bankName && data?.accountInfo?.bankAccountNumber);

  return { isRegistered, isPending };
}
